module.exports = require("./zen-observable.js").Observable;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/apollo-link-dedup/~/zen-observable/index.js
// module id = 850
// module chunks = 168707334958949